import {
  TextBlockItem,
  TextBlockItemStructured,
  TextBlockItemTypeEnum,
} from "./types";

export const isExternalReference = (url?: string): boolean =>
  !!url?.startsWith("http");

export function isTextBlockItemStructured(
  tab: TextBlockItem
): tab is TextBlockItemStructured {
  return tab.type === TextBlockItemTypeEnum.STRUCTURED_TEXT;
}

export const normalizeData = (
  value: number,
  [min, max]: [number, number]
): string => {
  if (value < min) {
    return "0";
  }

  if (value > max) {
    return "1";
  }

  return String((value - min) / (max - min));
};
